import Loc from "../../../services/localization";

const LocService = new Loc()
export default {
    props: [
        "activePage",
        "limit",
        "total"
    ],

    data() {
        return {
            locale: LocService,
            offset: 3,
            pages: Number,
            visiblePages: []
        }
    },

    methods: {
        calculatePages: calculatePages,
        goToPage: goToPage,
        first: first,
        last: last,
        next: next,
        prev: prev
    },

    watch: {
        "total": function (value) {
            this.calculatePages(this._props.activePage, this._props.limit, this._props.total);
        }
    },

    created() {
        this.calculatePages(this._props.activePage, this._props.limit, this._props.total);
    }
}

function calculatePages(currentPage, limit, totalCount) {
    this.pages = Math.ceil(totalCount / limit);
}

function goToPage(index) {
    this.$parent.pagination.page = index;
    this.$parent.load();
    window.scrollTo(0, 0);
}

function first() {
    this.goToPage(1);
}

function last() {
    this.goToPage(this.pages);
}

function next() {
    if (this._props.activePage < this.pages)
        this.goToPage(this._props.activePage + 1);
}

function prev() {
    if (this._props.activePage > 1)
        this.goToPage(this._props.activePage - 1);
}


// WEBPACK FOOTER //
// ./src/components/Shared/Pagination/Pagination.js